export default __webpack_public_path__ + "static/outsource@992-c9e8034afd786683681e04e1d3e2012c.png";